<div class="version-container">
  <div *ngIf="loading" class="loading">Loading version information...</div>
  
  <div *ngIf="!loading && !error" class="version-info">
    <div class="version-item">
      <span class="label">Client:</span> 
      <span class="value">v{{clientVersion?.version}}</span>
      <span class="env">({{clientVersion?.environment}})</span>
    </div>
    
    <div class="version-item">
      <span class="label">Server:</span> 
      <span class="value">v{{serverVersion?.version}}</span>
      <span class="env">({{serverVersion?.environment}})</span>
    </div>
    
    <div class="build-date">
      <span class="label">Built:</span> 
      <span class="value">{{serverVersion?.build_date | date:'medium'}}</span>
    </div>
  </div>
  
  <div *ngIf="error" class="error">
    Unable to fetch version information
  </div>
</div>
